import React from 'react';
import {
  Box,
  Flex,
  Heading,
  HStack,
  Button,
  Icon,
  Link
} from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { FaChartLine, FaTrophy, FaUsers, FaDharmachakra } from 'react-icons/fa';
import DashboardValueBoxes from './Charts/DashboardValueBoxes';

const MarketPerformanceSection = ({ 
  chartTimeframe, 
  setChartTimeframe, 
  getTimeframeData,
  goldColor,
  userStats
}) => {
  // Default user stats if not provided
  const defaultUserStats = {
    solContributed: 2.5,
    totalReferrals: 8,
    totalEarnings: 250,
    daoPower: 185
  };
  return (
    <Box 
      p={4} 
      bg="rgba(23, 25, 35, 0.9)"
      borderRadius="lg"
      borderWidth="1px"
      borderColor="gray.700"
      boxShadow="0 0 15px rgba(0, 0, 0, 0.3)"
      mb={4}
    >
      <Flex justify="space-between" align="center" mb={4}>
        <Heading size="sm" color="white" display="flex" alignItems="center">
          <Icon as={FaTrophy} mr={2} color="yellow.400" />
          Game Progress & Community Stats
        </Heading>
        <HStack spacing={2} justifyContent="flex-end">
          <Button 
            size="xs" 
            variant={chartTimeframe === "24h" ? "solid" : "outline"}
            colorScheme="gold"
            bg={chartTimeframe === "24h" ? "rgba(255, 215, 0, 0.2)" : "transparent"}
            color={chartTimeframe === "24h" ? goldColor : "gray.400"}
            borderColor={goldColor}
            onClick={() => setChartTimeframe("24h")}
            _hover={{ bg: "rgba(255, 215, 0, 0.1)" }}
          >
            24h
          </Button>
          <Button 
            size="xs" 
            variant={chartTimeframe === "7d" ? "solid" : "outline"}
            colorScheme="gold"
            bg={chartTimeframe === "7d" ? "rgba(255, 215, 0, 0.2)" : "transparent"}
            color={chartTimeframe === "7d" ? goldColor : "gray.400"}
            borderColor={goldColor}
            onClick={() => setChartTimeframe("7d")}
            _hover={{ bg: "rgba(255, 215, 0, 0.1)" }}
          >
            7d
          </Button>
          <Button 
            size="xs" 
            variant={chartTimeframe === "30d" ? "solid" : "outline"}
            colorScheme="gold"
            bg={chartTimeframe === "30d" ? "rgba(255, 215, 0, 0.2)" : "transparent"}
            color={chartTimeframe === "30d" ? goldColor : "gray.400"}
            borderColor={goldColor}
            onClick={() => setChartTimeframe("30d")}
            _hover={{ bg: "rgba(255, 215, 0, 0.1)" }}
          >
            30d
          </Button>
          <Button 
            size="xs" 
            variant={chartTimeframe === "all" ? "solid" : "outline"}
            colorScheme="gold"
            bg={chartTimeframe === "all" ? "rgba(255, 215, 0, 0.2)" : "transparent"}
            color={chartTimeframe === "all" ? goldColor : "gray.400"}
            borderColor={goldColor}
            onClick={() => setChartTimeframe("all")}
            _hover={{ bg: "rgba(255, 215, 0, 0.1)" }}
          >
            All
          </Button>
        </HStack>
      </Flex>
      
      {/* Dashboard Value Boxes */}
      <DashboardValueBoxes 
        chartData={getTimeframeData()} 
        timeframe={chartTimeframe} 
        userStats={userStats || defaultUserStats} 
      />
      
      {/* Chart Toggle Link */}
      <Flex justify="center" mt={2}>
        <Link as={RouterLink} to="/analytics" color="blue.400" fontSize="sm">
          <Flex align="center">
            <Icon as={FaChartLine} mr={1} />
            View Detailed Analytics
          </Flex>
        </Link>
      </Flex>
    </Box>
  );
};

export default MarketPerformanceSection;
